function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M54.1668 10.8334H10.8334C7.85425 10.8334 5.44383 13.2709 5.44383 16.25L5.41675 48.75C5.41675 51.7292 7.85425 54.1667 10.8334 54.1667H54.1668C57.1459 54.1667 59.5834 51.7292 59.5834 48.75V16.25C59.5834 13.2709 57.1459 10.8334 54.1668 10.8334ZM10.8334 21.6667L32.5001 35.2084L54.1667 21.6667V48.75H10.8334V21.6667ZM10.8334 16.25L32.5001 29.7917L54.1667 16.25H10.8334Z",
  fill: "url(#paint0_linear)"
});

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 32.5001,
  y1: 10.8334,
  x2: 32.5001,
  y2: 54.1667,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#0099BB"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#007A6A"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/MessageIcon.98ef47ed.svg";
export { SvgComponent as ReactComponent };